export const importDataStructure = {
  row1IsHeading: true,
  activeStep: 0,
  defaultDateFormat: '',
  defaultAccount: '',
  dataColumns: [],
  finalizedRecords: [],
  defaultHeadings: ['Date', 'Class', 'Category', 'Description', 'Total']
};
